var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSelf)?_c('LTooltip',{attrs:{"label":_vm.$t("common.table.self"),"position":"is-bottom","type":"is-info"}},[_c('b-icon',{attrs:{"icon":"portrait","size":"is-small","type":"is-primary"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }